function normalizeRoot(root) {
  if (!root || root === '') return '/';

  try {
    var url = new URL(root, window.location.origin);
    root = url.pathname || '/';
  } catch (e) {}

  if (root === '/') return '/';

  return root.replace(/\/$/, '');
}

function normalizePath(path) {
  if (!path || path === '') return '/';
  if (path.charAt(0) !== '/') return '/' + path;
  return path;
}

function getRootPath(root) {
  if (!root || root === '') return '/';

  try {
    var url = new URL(root, window.location.origin);
    return normalizeRoot(url.pathname || '/');
  } catch (e) {
    return normalizeRoot(root);
  }
}

function stripCurrentLocalePrefix(path, currentRoot, availableRoots) {
  path = normalizePath(path);
  currentRoot = getRootPath(currentRoot);

  if (currentRoot !== '/') {
    if (path === currentRoot) return '/';

    if (path.indexOf(currentRoot + '/') === 0) {
      return path.slice(currentRoot.length) || '/';
    }
  }

  if (Array.isArray(availableRoots) && availableRoots.length) {
    var roots = availableRoots
      .map(getRootPath)
      .filter(function (root) {
        return root && root !== '/';
      })
      .sort(function (a, b) {
        return b.length - a.length;
      });

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];

      if (path === root) return '/';

      if (path.indexOf(root + '/') === 0) {
        return path.slice(root.length) || '/';
      }
    }
  }

  return path;
}

function isAbsoluteUrl(value) {
  return /^https?:\/\//i.test(value || '');
}

function isDifferentOrigin(url) {
  try {
    var parsedUrl = new URL(url, window.location.origin);
    return parsedUrl.origin !== window.location.origin;
  } catch (e) {
    return false;
  }
}

function joinRootAndPath(targetRoot, relativePath) {
  if (!relativePath || relativePath === '') relativePath = '/';
  relativePath = normalizePath(relativePath);

  var targetUrl;

  try {
    targetUrl = new URL(targetRoot, window.location.origin);
  } catch (e) {
    targetUrl = new URL('/', window.location.origin);
  }

  var targetPath = normalizeRoot(targetUrl.pathname || '/');

  if (targetPath === '/') {
    targetUrl.pathname = relativePath;
  } else {
    targetUrl.pathname = targetPath + (relativePath === '/' ? '' : relativePath);
  }

  /*
   * Se il targetRoot è un dominio diverso, devo restituire l'URL completo.
   * Altrimenti Shopify resterebbe sul dominio corrente.
   */
  if (targetUrl.origin !== window.location.origin) {
    return targetUrl.href;
  }

  return targetUrl.pathname;
}

function getForcedLocaleUrl(selectEl) {
  if (!selectEl) return null;

  var selectedOption = selectEl.options[selectEl.selectedIndex];
  if (!selectedOption) return null;

  /*
   * Caso speciale SGM:
   * Italiano deve sempre andare alla home base italiana.
   */
  var italianUrl =
    selectedOption.getAttribute('data-sgm-italian-url') ||
    selectedOption.getAttribute('data-sgm-url');

  if (italianUrl) {
    return italianUrl;
  }

  /*
   * Fallback di sicurezza:
   * se l'opzione è italiana e il value è un URL assoluto esterno,
   * lo uso direttamente.
   */
  var isoCode = (selectedOption.getAttribute('data-iso-code') || '').toLowerCase();
  var value = selectedOption.value || '';

  if ((isoCode === 'it' || isoCode === 'it-it') && isAbsoluteUrl(value)) {
    return value;
  }

  return null;
}

function buildNextLocaleUrl(selectEl) {
  if (!selectEl) return null;

  var forcedUrl = getForcedLocaleUrl(selectEl);
  if (forcedUrl) {
    return forcedUrl;
  }

  var targetRoot = selectEl.value || '/';
  var currentRoot =
    selectEl.getAttribute('data-current-locale-root') ||
    document.body.getAttribute('data-current-locale-root') ||
    '/';

  var availableRoots = Array.prototype.map.call(selectEl.options, function (option) {
    return option.value || '/';
  });

  var path = window.location.pathname || '/';
  var query = window.location.search || '';
  var hash = window.location.hash || '';

  var relativePath = stripCurrentLocalePrefix(path, currentRoot, availableRoots);
  var nextPath = joinRootAndPath(targetRoot, relativePath);

  return nextPath + query + hash;
}

function goToSelectedLocale(selectEl) {
  if (!selectEl || selectEl.dataset.isNavigating === 'true') return;

  var nextUrl = buildNextLocaleUrl(selectEl);
  if (!nextUrl) return;

  selectEl.dataset.isNavigating = 'true';
  window.location.assign(nextUrl);
}

$('.custom-lang-select')
  .select2({
    placeholder: '',
    minimumResultsForSearch: Infinity,
    width: 'style'
  })
  .off('change.langSwitcher select2:select.langSwitcher')
  .on('change.langSwitcher select2:select.langSwitcher', function () {
    goToSelectedLocale(this);
  });


(function () {
  const TARGET_SELECTORS = [
    '.snize-ac-results',
    '.snize-ac-results-content'
  ];

  const observedElements = new WeakSet();

  function isTargetElement(el) {
    if (!el || !el.classList) return false;

    return (
      el.classList.contains('snize-ac-results') ||
      el.classList.contains('snize-ac-results-content')
    );
  }

  function forceWidth(el) {
    if (!isTargetElement(el)) return;

    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('max-width', '100%', 'important');
  }

  function observeElement(el) {
    if (!isTargetElement(el) || observedElements.has(el)) return;

    observedElements.add(el);
    forceWidth(el);

    const elementObserver = new MutationObserver(() => {
      forceWidth(el);
    });

    elementObserver.observe(el, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  function scanAndObserve(root) {
    if (!root || root.nodeType !== 1) return;

    if (isTargetElement(root)) {
      observeElement(root);
    }

    TARGET_SELECTORS.forEach((selector) => {
      if (root.querySelectorAll) {
        root.querySelectorAll(selector).forEach(observeElement);
      }
    });
  }

  function forceAll() {
    TARGET_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach(forceWidth);
    });
  }

  function init() {
    scanAndObserve(document.documentElement);
    forceAll();

    const domObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            scanAndObserve(node);
          }
        });
      });

      forceAll();
    });

    domObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

